module.exports = __webpack_public_path__ + "img/rotating_telehandlers.eefa176d.jpg";